import { render, staticRenderFns } from "./IncentivesActivityDetails.vue?vue&type=template&id=22287e05&"
import script from "./IncentivesActivityDetails.vue?vue&type=script&setup=true&lang=js&"
export * from "./IncentivesActivityDetails.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./IncentivesActivityDetails.vue?vue&type=style&index=0&id=22287e05&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports